let text1 = `
    제 1 장 총 칙<br>
    <br><br>
    제 1 조 (목적)<br>
    이 약관은 DX손해사정 주식회사(이하 “회사”라 합니다)가 운영하는 DX손해사정(이하 "사이트"라 합니다)에서 제공하는 인터넷서비스(이하 "서비스"라 합니다)의 이용 조건 및 절차에 관한 기본적인 사항을 규정함을 목적으로 합니다.<br>
    <br><br>
    제 2 조 (약관의 효력 및 변경)<br>
    ① 이 약관은 서비스 화면이나 기타의 방법으로 회원에게 공지함으로써 효력을 발생합니다.<br>
    ② 사이트는 이 약관의 내용을 변경할 수 있으며, 변경된 약관은 제1항과 같은 방법으로 공지 또는 통지함으로써 효력을 발생합니다.<br>
    <br><br>
    제 3 조 (용어의 정의)<br>
    이 약관에서 사용하는 용어의 정의는 다음과 같습니다.<br>
    ① 회원 : 사이트와 서비스 이용계약을 체결하거나 이용자 아이디(ID)를 부여받은 개인 또는 단체를 말합니다.<br>
    ② 신청자 : 회원가입을 신청하는 개인 또는 단체를 말합니다.<br>
    ③ 아이디(ID) : 회원의 식별과 서비스 이용을 위하여 회원이 정하고 사이트가 승인하는 문자와 숫자의 조합을 말합니다.<br>
    ④ 비밀번호 : 회원이 부여 받은 아이디(ID)와 일치된 회원임을 확인하고, 회원 자신의 비밀을 보호하기 위하여 회원이 정한 문자와 숫자의 조합을 말합니다.<br>
    ⑤ 해지 : 사이트 또는 회원이 서비스 이용계약을 취소하는 것을 말합니다.<br>
    <br><br>
    제 2 장 서비스 이용계약<br>
    <br><br>
    제 4 조 (이용계약의 성립)<br>
    ① 이용약관 하단의 동의 버튼을 누르면 이 약관에 동의하는 것으로 간주됩니다.<br>
    ② 이용계약은 서비스 이용희망자의 이용약관 동의 후 이용 신청에 대하여 사이트가 승낙함으로써 성립합니다.<br>
    <br><br>
    제 5 조 (이용신청)<br>
    ① 신청자가 본 서비스를 이용하기 위해서는 사이트 소정의 가입신청 양식에서 요구하는 이용자 정보를 기록하여 제출해야 합니다.<br>
    ② 가입신청 양식에 기재하는 모든 이용자 정보는 모두 실제 데이터인 것으로 간주됩니다. 실명이나 실제 정보를 입력하지 않은 사용자는 법적인 보호를 받을 수 없으며, 서비스의 제한을 받을 수 있습니다.<br>
    <br><br>
    제 6 조 (이용신청의 승낙)<br>
    ① 사이트는 신청자에 대하여 제2항, 제3항의 경우를 예외로 하여 서비스 이용신청을 승낙합니다.<br>
    ② 사이트는 다음에 해당하는 경우에 그 신청에 대한 승낙 제한사유가 해소될 때까지 승낙을 유보할 수 있습니다.<br>
    가. 서비스 관련 설비에 여유가 없는 경우<br>
    나. 기술상 지장이 있는 경우<br>
    다. 기타 사이트가 필요하다고 인정되는 경우<br>
    ③ 사이트는 신청자가 다음에 해당하는 경우에는 승낙을 거부할 수 있습니다.<br>
    가. 다른 개인(사이트)의 명의를 사용하여 신청한 경우<br>
    나. 이용자 정보를 허위로 기재하여 신청한 경우<br>
    다. 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우<br>
    라. 기타 사이트 소정의 이용신청요건을 충족하지 못하는 경우<br>
    <br><br>
    제 7 조 (이용자정보의 변경)<br>
    회원은 이용 신청시에 기재했던 회원정보가 변경되었을 경우에는, 온라인으로 수정하여야 하며 변경하지 않음으로 인하여 발생되는 모든 문제의 책임은 회원에게 있습니다.<br>
    <br><br>
    제 3 장 계약 당사자의 의무<br>
    <br><br>
    제 8 조 (사이트의 의무)<br>
    ① 사이트는 회원에게 각 호의 서비스를 제공합니다.<br>
    가. 신규서비스와 도메인 정보에 대한 뉴스레터 발송<br>
    나. 추가 도메인 등록시 개인정보 자동 입력<br>
    다. 도메인 등록, 관리를 위한 각종 부가서비스<br>
    ② 사이트는 서비스 제공과 관련하여 취득한 회원의 개인정보를 회원의 동의없이 타인에게 누설, 공개 또는 배포할 수 없으며, 서비스관련 업무 이외의 상업적 목적으로 사용할 수 없습니다. 단, 다음 각 호에 해당하는 경우는 예외입니다.<br>
    가. 전기통신기본법 등 법률의 규정에 의해 국가기관의 요구가 있는 경우<br>
    나. 범죄에 대한 수사상의 목적이 있거나 정보통신윤리 위원회의 요청이 있는 경우<br>
    다. 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우<br>
    ③ 사이트는 이 약관에서 정한 바에 따라 지속적, 안정적으로 서비스를 제공할 의무가 있습니다.<br>
    <br><br>
    제 9 조 (회원의 의무)<br>
    ① 회원은 서비스 이용 시 다음 각 호의 행위를 하지 않아야 합니다.<br>
    가. 다른 회원의 ID를 부정하게 사용하는 행위<br>
    나. 서비스에서 얻은 정보를 회사의 사전승낙 없이 회원의 사이트 내 이용 이외의 목적으로 복제하거나 이를 변경, 출판 및 방송 등에 사용하거나 다른 매체에 게시하거나 타인에게 제공하는 행위<br>
    다. 회사의 저작권, 타인의 저작권 등 기타 권리를 침해하는 행위<br>
    라. 사이트를 손상시키거나 손상시킬 수 있는 방식으로 사용하는 행위<br>
    마. 사이트에 대한 사용자 액세스 권한에 영향을 미치거나 미칠 수 있는 방식으로 사용하는 행위<br>
    바. 관련 법령 또는 규정에 위배되는 방식으로 사이트를 사용하거나, 제3자에게 피해를 줄 수 있는 방식으로 사용하는 행위<br>
    사. 사이트와 관련하여 데이터 마이닝, 데이터 수집, 데이터 추출 또는 기타 유사한 활동에 관여하는 행위아. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등을 타인에게 유포하는 행위<br>
    자. 범죄와 결부된다고 객관적으로 판단되는 행위<br>
    차. 기타 관계법령에 위배되는 행위<br>
    ② 회원은 사이트 또는 서비스를 이용하여 영업활동을 할 수 없으며, 회사는 회원이 이를 위반하여 발생한 결과에 대하여 책임을 지지 않습니다.<br>
    ③ 회원은 관계법령, 이 약관에서 규정하는 사항, 서비스 이용 안내 및 주의 사항을 준수하여야 합니다.<br>
    ④ 회원은 내용별로 사이트가 서비스 공지사항에 게시하거나 별도로 공지한 이용 제한 사항을 준수하여야 합니다.<br>
    <br><br>
    제 4 장 서비스 제공 및 이용<br>
    <br><br>
    제 10 조 (회원 아이디(ID)와 비밀번호 관리에 대한 회원의 의무)<br>
    ① 아이디(ID)와 비밀번호에 대한 모든 관리는 회원에게 책임이 있습니다. 회원에게 부여된 아이디(ID)와 비밀번호의 관리소홀, 부정사용에 의하여 발생하는 모든 결과에 대한 전적인 책임은 회원에게 있습니다.<br>
    ② 자신의 아이디(ID)가 부정하게 사용된 경우 또는 기타 보안 위반에 대하여, 회원은 반드시 사이트에 그 사실을 통보해야 합니다.<br>
    <br><br>
    제 11 조 (서비스 제한 및 정지)<br>
    ① 사이트는 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우와 전기통신사업법에 의한 기간통신 사업자가 전기통신서비스를 중지하는 등 기타 불가항력적 사유가 있는 경우에는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있습니다.<br>
    ② 사이트는 제1항의 규정에 의하여 서비스의 이용을 제한하거나 정지할 때에는 그 사유 및 제한기간 등을 지체없이 회원에게 알려야 합니다.<br>
    <br><br>
    제5장 계약사항의 변경, 해지<br>
    <br><br>
    제 12 조 (정보의 변경)<br>
    회원이 주소, 비밀번호 등 고객정보를 변경하고자 하는 경우에는 홈페이지의 회원정보 변경 서비스를 이용하여 변경할 수 있습니다.<br>
    <br><br>
    제 13 조 (계약사항의 해지)<br>
    ①회원은 서비스 이용계약을 해지할 수 있으며, 해지할 경우에는 본인이 직접 서비스를 통하거나 전화 또는 온라인 등으로 사이트에 해지신청을 하여야 합니다. 사이트는 해지신청이 접수된 당일부터 해당 회원의 서비스 이용을 제한할 수 있습니다. 회사는 회원이 다음 각 호에 해당하여 이용계약을 해지하고자 할 경우에는 해지조치 7일전까지 그 뜻을 해당 회원에게 통지하여 소명할 기회를 주어야 합니다.<br>
    1.회원이 본 계약 또는 이용제한 규정을 위반하거나 그 위반에 따른 이용제한 기간 내에 제한 사유를 해소하지 않는 경우<br>
    2.정보통신윤리위원회가 이용계약의 해지를 요구한 경우<br>
    3.회원이 정당한 사유 없이 회사의 소명 요청에 응하지 아니한 경우<br>
    4.타인 명의로 신청을 하였거나 신청서 내용의 허위 기재 또는 허위서류를 첨부하여 이용계약을 체결한 경우<br>
    ② 사이트는 본 조 제1항 각호에 의하여 해지된 회원에 대해서는 별도로 정한 기간동안 가입을 제한할 수 있습니다.
    <br><br>
    제6장 손해배상<br>
    <br><br>
    제 14 조 (면책조항)<br>
    ① 사이트는 회원이 서비스를 이용하여 얻은 정보 및 자료 등에 대하여 책임을 지지 않고, 회원이 서비스 제공으로부터 기대되는 이익을 얻지 못하였거나 서비스 자료에 대한 취사선택 또는 이용으로 발생하는 손해 등에 대해서 책임을 지지 않습니다.<br>
    ② 회원의 귀책사유나 제3자의 행위로 인하여 서비스에 장애가 발생하거나 회원의 데이터가 훼손된 경우, 사이트는 이로 인하여 발생한 손해에 대해 일체의 책임을 지지 않습니다.<br>
    ③ 사이트는 회원 또는 제3자가 게시 또는 전송한 정보, 자료, 사실의 신뢰도, 정확성 등 기타 어떠한 내용에 관하여서도 책임을 지지 않습니다.<br>
    ④ 상표권이 있는 도메인의 경우, 이로 인해 발생할 수도 있는 손해나 배상에 대한 책임은 구매한 회원 당사자에게 있으며, 사이트는 이에 대한 일체의 책임을 지지 않습니다.<br>
    <br><br>
    제 15 조 (관할법원)<br>
    서비스와 관련하여 회사와 회원간에 분쟁이 발생할 경우 회사의 본사 소재지를 관할하는 법원을 관할법원으로 합니다.<br>
    <br><br>
    [부칙]<br>
    (시행일) 이 약관은 2025년 08월부터 시행합니다.
`
let text2 = `
    1. 목적<br>
    본 방침은 (주)DX손해사정(이하 ‘회사'라 한다)이 취급하는 모든 개인정보는 개인정보보호법 등 관련 법령 상의 개인정보보호 규정을 준수하여 정보주체(이용자)의 개인정보 및 권익을 보호하고 개인정보와 관련한 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.<br>
    <br>
    2. 개인정보의 처리 항목<br>
    회사는 아래와 같은 항목을 처리하고 있으며, 서비스 제공을 위해 필요한 최소한의 개인정보만을 수집하고 만 14세 미만의 개인정보는 수집하지 않습니다. 당사의 서비스를 이용하기 위해서는 필수항목과 선택항목을 기입하여야 하며, 선택항목은 기입하지 않더라도 기본 서비스 제공에는 지장이 없습니다. 당사는 동의에 의해 수집한 정보를 적법하게 처리합니다<br>
    &nbsp;&nbsp;&nbsp;&nbsp;1. 직원채용 및 인사관리<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- 필수항목: 이름, 성별, 주소, 생년월일, 사진, 연락처(이메일주소, 휴대폰번호), 보훈여부(해당자에 한함), 병역사항(해당자에 한함), 학력사항, 경력사항, 프로젝트사항, 자격사항, 자기소개서, 필기/실기전형 결과(해당자에 한함).<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- 선택항목: 없음<br>
    &nbsp;&nbsp;&nbsp;&nbsp;2. 제품 문의 대응<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- 필수항목: 기업/기관명, 성명, 연락처, 이메일, 문의내용, 유입경로<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- 선택항목: 홈페이지, 직급/직책<br>
    &nbsp;&nbsp;&nbsp;&nbsp;3. 마케팅(수신동의 선택)<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- 필수항목: 기업/기관명, 성명, 연락처, 이메일<br>
    &nbsp;&nbsp;&nbsp;&nbsp;4. 인터넷 서비스 이용<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- 항목: IP주소, 쿠키, 서비스 이용기록, 방문기록<br>
    <br>
    3. 개인정보의 처리 목적<br>
    회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음 목적 이외의 용도로는 이용되지 않으며 이용 목적이 변경되는 경우에는 「개인정보 보호법 제 18 조」에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;1. 직원채용 및 인사관리: 입사지원 관련 행정 처리 및 입사자 채용업무와 관련한 목적으로 개인정보를 처리하고 있습니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;2. 제품 문의 대응: 회사 제품에 대한 문의 내용 수집 및 대응을 위해서 개인정보를 처리하고 있습니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;3. 마케팅: 수신동의를 선택한 정보주체의 개인정보를 이벤트 및 세미나 정보 안내 등 광고성 정보 전달, 인구통계 학적 특성에 따른 서비스 제공 및 광고 게재, 웹진 메일 발송 등을 하기 위해 처리하고 있습니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;4. 인터넷 서비스 이용 과정에서 2조의 3 호의 개인정보 항목이 자동으로 생성되어 수집될 수 있습니다.<br>
    <br>
    4. 개인정보 처리 및 보유기간<br>
    ① 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리 및 보유하며, 개인정보의 처리목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.<br>
    ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;1. 직원채용 및 인사관리: 채용 과정에서 수집된 입사지원자들의 개인정보는 지원한 직무의 채용 종료시 파기되며, 입사자의 개인정보는 퇴사 후에는 사고예방 조사 분쟁해결 민원처리 법령상 의무 이행만을 위하여 보유ㆍ이용됩니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;2. 제품 문의 대응: 수집·이용 및 제공 등에 관한 동의일로부터 1 년간 보유ㆍ이용됩니다. 다만, 수집한 개인정보의 삭제요청을 하는 경우 해당 정보는 즉시 파기됩니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;3. 마케팅: 수집·이용 및 제공 등에 관한 동의일로부터 1 년간 보유ㆍ이용됩니다. 다만, 수집한 개인정보의 삭제요청을 하는 경우 해당 정보는 즉시 파기됩니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;4. 인터넷 서비스 이용/방문 기록은 「통신비밀보호법」의 규정에 의하여 3개월간 보관합니다.<br>
    <br>
    5. 개인정보의 제3자 제공<br>
    회사는 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며 정보주체의 동의 법률의 특별한 규정 등 「개인정보 보호법 제18조 (개인정보의 목적 외 이용 제공 제한 규정)」에 따라 법률에서 정하는 경우를 제외하고는 정보주체의 동의 없이 제3자에게 제공하지 않습니다. 단 다음 각 호의 경우에는 개인정보를 목적 외의 용도로 이용하거나 이를 제3자에게 제공할 수 있습니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;1. 정보주체의 동의를 받은 경우<br>
    &nbsp;&nbsp;&nbsp;&nbsp;2. 다른 법률에 특별한 규정이 있는 경우<br>
    &nbsp;&nbsp;&nbsp;&nbsp;3. 정보주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소 불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우<br>
    &nbsp;&nbsp;&nbsp;&nbsp;4. 범죄의 수사와 공소의 제기 및 유지를 위하여 필요한 경우<br>
    <br>
    6. 개인정보 처리 위탁<br>
    회사는 원칙적으로 정보주체의 정보를 외부 업체에 위탁하지 않습니다. 다만, 회사가 제3자에게 개인정보의 처리 업무를 위탁하는 경우에는 「개인정보보호법 제26조 (업무위탁에 따른 개인정보의 처리 제한) 」에 따라 위탁하며 위탁 업무의 내용과 수탁자를 공지사항 및 개인정보처리방침을 통해 고지하겠습니다. 또한 필요한 경우 사전 동의를 받도록 하겠습니다.<br>
    <br>
    7. 정보주체의 권리, 의무 및 행사방법<br>
    ① 정보주체는 본 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;1. 개인정보 열람요구<br>
    &nbsp;&nbsp;&nbsp;&nbsp;2. 오류 등이 있을 경우 정정요구<br>
    &nbsp;&nbsp;&nbsp;&nbsp;3. 삭제요구<br>
    &nbsp;&nbsp;&nbsp;&nbsp;4. 처리정지 요구<br>
    ② 1항에 따른 권리행사는 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 본 회사는 이에 대해 지체 없이 조치하겠습니다.<br>
    ③ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법 제35조 제4항, 제37조 제2항」에 의하여 정보주체의 권리가 제한될 수 있습니다.<br>
    ④ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.<br>
    ⑤ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.<br>
    ⑥ 정보주체가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다.<br>
    <br>
    8. 개인정보의 파기 절차 및 방법<br>
    ① 회사는 개인정보 보유기간의 경과 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이(5일 이내) 해당 개인정보를 파기합니다.<br>
    ② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관장소를 달리 하여 보존합니다.<br>
    ③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;1. 파기절차<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;2. 파기방법<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;회사는 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.<br>
    <br>
    9. 개인정보의 안전성 확보조치<br>
    회사는 개인정보의 안전성 확보를 위해 다음과 같이 기술적, 관리적 및 물리적 조치를 취하고 있습니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;1. 관리적 조치: 내부관리계획 수립 및 시행, 전담조직 운영, 정기적 직원 교육<br>
    &nbsp;&nbsp;&nbsp;&nbsp;2. 기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 개인정보의 암호화, 보안프로그램 설치 및 갱신<br>
    &nbsp;&nbsp;&nbsp;&nbsp;3. 물리적 조치: 전산실, 자료보관실 등의 접근통제<br>
    <br>
    10. 권익침해 구제방법<br>
    ① 정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원, 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.<br>
    이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;1. 개인정보분쟁조정위원회: (국번없이) 1833-6972 (www.kopico.go.kr)<br>
    &nbsp;&nbsp;&nbsp;&nbsp;2. 개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)<br>
    &nbsp;&nbsp;&nbsp;&nbsp;3. 대검찰청: (국번없이) 1301 (www.spo.go.kr)<br>
    &nbsp;&nbsp;&nbsp;&nbsp;4. 경찰청 사이버안전지킴이: (국번없이) 182 (ecrm.cyber.go.kr)<br>
    ② 회사는 정보주체의 개인정보자기결정권을 보장하고, 개인정보 침해로 인한 상담 및 피해구제를 위해 노력하고 있으며, 신고나 상담이 필요한 경우 아래의 담당부서로 연락해 주시기 바랍니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;- 경영지원팀: 02-712-9039<br>
    ③ 「개인정보 보호법 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등) 」의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;1. 중앙행정심판위원회: (국번없이) 110 (www.simpan.go.kr)<br>
    <br>
    11. 개인정보 보호책임자 등에 관한 사항<br>
    ① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자 등을 지정하고 있습니다.<br>
    &nbsp;&nbsp;&nbsp;&nbsp;1. 개인정보 보호책임자<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;최현보 부사장 / 02-712-9039 / privacy@dxclaim.com<br>
    &nbsp;&nbsp;&nbsp;&nbsp;2. 개인정보 보호담당자<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;조상민 부장 / 02-712-9039 / privacy@dxclaim.com<br>
    ② 정보주체는 회사의 서비스 또는 사업을 이용하면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다.<br>
    회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.<br>
    ③ 정보주체는 「개인정보 보호법 제35조」에 따른 개인정보의 열람 청구를 개인정보 보호 담당부서에 할 수 있습니다.<br>
    회사는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.<br>
    <br>
    12. 개인정보 처리방침의 변경<br>
    본 방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 공지사항을 통하여 고지할 것입니다.<br>
    <br>
    개인정보처리방침 공고일: 2025.08.25<br>
    개인정보처리방침 시행일: 2025.08.25
`
export {text1, text2}